// Langue de l'interface : français ou anglais (logique pure, partagée par l'app et le site).
// Dans le code, chaque texte est écrit dans les deux langues côte à côte : t('Bonjour', 'Hello').
// L'app choisit la langue du téléphone (src/lib/locale.ts), le site celle du navigateur.

export type Lang = 'fr' | 'en';

let current: Lang = 'fr';

export const getLang = (): Lang => current;

export function setLang(lang: Lang) {
  current = lang;
}

/** Langue à partir d'un code (« fr », « fr-BE », « en-US », « de »…) : français ou, sinon, anglais. */
export function langFromCode(code: string | null | undefined): Lang {
  const c = (code ?? '').toLowerCase();
  if (c.startsWith('fr')) return 'fr';
  if (c.startsWith('en')) return 'en';
  return 'fr'; // autres langues : français, langue principale de l'app
}

/** Texte dans la langue courante. */
export const t = (fr: string, en: string): string => (current === 'en' ? en : fr);

/** Code de langue complet (dates, nombres, synthèse vocale). */
export const locale = (): string => (current === 'en' ? 'en-GB' : 'fr-FR');

/** Pluriel simple : plural(3, 'participant', 'participants') */
export const plural = (n: number, one: string, many: string) => (Math.abs(n) >= 2 ? many : one);
